import React, { useState, useRef, useEffect } from "react";

import "../styles/Reservas.css";

import Header from "../components/Header";
import Footer from "../components/Footer";

import { database } from "../services/firebase";
import { ref, onValue, push, set, get } from "firebase/database";

import { DayPicker } from "react-day-picker";
import { ptBR } from "date-fns/locale";
import { format } from "date-fns";
import "react-day-picker/dist/style.css";

import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

import { CiCalendarDate } from "react-icons/ci";

import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
  Typography,
  Paper
} from "@mui/material";

const steps = ["Valores e Tolerância", "Política de Reservas", "Realizar Reserva"];


const capacidadeTotalSalao = 48; // 14 mesas 2p (28) + 2 mesas 4p (8) + 1 mesa 8p (8)
const capacidadeTotalDeck = 32; // ajuste conforme sua estrutura real
// ==============================================================================

const Reservas = () => {
  const [activeStep, setActiveStep] = useState(0);

  // Checkboxes obrigatórios
  const [accepted1, setAccepted1] = useState(false);
  const [accepted2, setAccepted2] = useState(false);

  const [formOn, setFormOn] = useState(false);

  const [loading, setLoading] = useState(false);
  const [toastOpen, setToastOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("success");

  // -------- FORM STATES --------
  const [calendarOpen, setCalendarOpen] = useState(false);
  const datepickerRef = useRef(null);

  const [date, setDate] = useState("");
  const [period, setPeriod] = useState("");
  const [time, setTime] = useState("");
  const [guests, setGuests] = useState("");
  const [local, setLocal] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [telephone, setTelephone] = useState("");

  const lunchTimes = ["13:15", "13:30", "14:00"];
  const dinnerTimes = ["19:15", "19:30", "20:00"];

  const [diasConfig, setDiasConfig] = useState({});

  const [almocoDisponivel, setAlmocoDisponivel] = useState(true);
  const [jantarDisponivel, setJantarDisponivel] = useState(true);

  const [capacidadeRestante, setCapacidadeRestante] = useState(null);

  const WHATSAPP_NUMBER = "5532999298502";

  const availableTimes =
    period === "lunch"
      ? lunchTimes
      : period === "dinner"
        ? dinnerTimes
        : [];

  // ==============================================================================
  // 🔥 FECHA DATEPICKER AO CLICAR FORA
  // ==============================================================================
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!calendarOpen) return;
      if (event.target.closest(".datepicker-wrapper")) return;

      if (
        datepickerRef.current &&
        !datepickerRef.current.contains(event.target)
      ) {
        setCalendarOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [calendarOpen]);

  useEffect(() => {

    const diasRef = ref(database, "config/dias");

    const unsub = onValue(diasRef, (snap) => {
      if (snap.exists()) {
        setDiasConfig(snap.val());
      } else {
        setDiasConfig({});
      }
    });

    return () => unsub();

  }, []);

  useEffect(() => {

    if (!date) {
      setAlmocoDisponivel(true);
      setJantarDisponivel(true);
      return;
    }

    const key = format(date, "yyyy-MM-dd");
    const config = diasConfig[key];

    if (!config) {
      const day = date.getDay(); // 0 = domingo, 1 = segunda

      // segunda-feira: tudo fechado
      if (day === 1) {
        setAlmocoDisponivel(false);
        setJantarDisponivel(false);
        return;
      }

      // domingo: só almoço
      if (day === 0) {
        setAlmocoDisponivel(true);
        setJantarDisponivel(false);
        return;
      }

      // terça a sábado: tudo aberto
      setAlmocoDisponivel(true);
      setJantarDisponivel(true);
      return;
    }

    setAlmocoDisponivel(config.almoco === true);
    setJantarDisponivel(config.jantar === true);

    // 🔥 se o período selecionado ficou inválido, limpa
    if (
      (period === "lunch" && config.almoco !== true) ||
      (period === "dinner" && config.jantar !== true)
    ) {
      setPeriod("");
      setTime("");
    }

  }, [date, diasConfig]);

  const isDayDisabled = (day) => {
    // 🔒 datas passadas
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (day < today) return true;

    const key = format(day, "yyyy-MM-dd");
    const config = diasConfig[key];

    // 🔥 CONFIG ADMIN SEMPRE MANDA
    if (config) {
      return !config.almoco && !config.jantar;
    }

    const dow = day.getDay(); // 0 dom, 1 seg

    // segunda-feira: fechado total
    if (dow === 1) return true;

    // domingo: tem almoço → dia válido
    if (dow === 0) return false;

    // terça a sábado: aberto normal
    return false;
  };

  useEffect(() => {

    async function atualizarCapacidade() {
      if (!date || !period || !local) {
        setCapacidadeRestante(null);
        return;
      }

      const formattedDate = format(date, "yyyy-MM-dd");
      const periodKey = period === "lunch" ? "almoco" : "jantar";
      const localKey = local === "Salão" ? "salao" : "deck";

      const capacidadeTotal = localKey === "salao" ? 44 : 16;

      const usoRef = ref(database, `reservas_uso/${formattedDate}/${periodKey}/${localKey}/capacidade_usada`);
      const snap = await get(usoRef);
      const usada = snap.exists() ? snap.val() : 0;

      setCapacidadeRestante(capacidadeTotal - usada);
    }

    atualizarCapacidade();

  }, [date, period, local]);

  // FUNÇÃO PRINCIPAL — VALIDA E CRIA RESERVA
  const getCapacidadeUsada = async (formattedDate, periodKey, localKey) => {
    const usoRef = ref(database, `reservas_uso/${formattedDate}/${periodKey}/${localKey}/capacidade_usada`);
    const snap = await get(usoRef);
    return snap.exists() ? snap.val() : 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isTimeAvailable(date, period, time)) {
      showToast("Horário indisponível. Escolha outro horário.", "error");
      return;
    }

    if (!date || !period || !telephone || !local || !time || !guests || !firstName || !lastName) {
      showToast("Preencha todos os campos!", "error");
      return;
    }

    const phoneRegex = /^\(\d{2}\) \d{5}-\d{4}$/;
    if (!phoneRegex.test(telephone)) {
      showToast("Telefone inválido! Use (XX) XXXXX-XXXX", "error");
      return;
    }

    // validação final de horário


    setLoading(true);

    try {
      const formattedDate = format(date, "yyyy-MM-dd");
      const periodKey = period === "lunch" ? "almoco" : "jantar";
      const localKey = local === "Salão" ? "salao" : "deck";

      const capacidadeTotal = localKey === "salao" ? 44 : 16;

      // 🔥 Busca capacidade já utilizada no Firebase
      const capacidadeUsada = await getCapacidadeUsada(formattedDate, periodKey, localKey);

      // 🔥 Validação antes de criar reserva
      if (capacidadeUsada + Number(guests) > capacidadeTotal) {
        setLoading(false);
        showToast("Não há disponibilidade para essa quantidade de pessoas.", "error");
        return;
      }

      // 🔥 Cria reserva pendente
      const reservaRef = ref(database, `reservas/${formattedDate}/${periodKey}`);
      const newReservaRef = push(reservaRef);

      await set(newReservaRef, {
        primeiroNome: firstName,
        sobrenome: lastName,
        telefone: telephone,
        pessoas: guests,
        data: formattedDate,
        horario: time,
        periodo: periodKey,
        local,
        status: "pendente",
        timestamp: Date.now()
      });

      // 🔥 Atualiza capacidade usada no Firebase
      const usoRef = ref(database, `reservas_uso/${formattedDate}/${periodKey}/${localKey}/capacidade_usada`);
      await set(usoRef, capacidadeUsada + Number(guests));

      clearForm();
      showToast("Reserva registrada com sucesso! Redirecionando para o WhatsApp...", "success");

      // (opcional) espera um tiquinho pro usuário ver o toast
      setTimeout(() => {
        redirectToWhatsapp();
        clearForm();
      }, 500);

    } catch (error) {
      console.error("Erro ao salvar reserva:", error);
      showToast("Erro ao salvar a reserva.", "error");
    }



    setLoading(false);
  };

  // ==============================================================================
  // HELPERS
  // ==============================================================================
  const showToast = (msg, type = "success") => {
    setToastMessage(msg);
    setToastType(type);
    setToastOpen(true);
  };

  const clearForm = () => {
    setFirstName("");
    setLastName("");
    setTelephone("");
    setGuests("");
    setPeriod("");
    setTime("");
    setLocal("");
    setDate("");
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const isTimeAvailable = (selectedDate, selectedPeriod, selectedTime) => {
    if (!selectedDate || !selectedPeriod || !selectedTime) return true;

    const now = new Date();

    // 📌 Verifica se a data é hoje
    const isToday =
      selectedDate.getDate() === now.getDate() &&
      selectedDate.getMonth() === now.getMonth() &&
      selectedDate.getFullYear() === now.getFullYear();

    if (!isToday) return true; // qualquer horário permitido se não for hoje

    // 📌 transforma "13:15" em Date
    const [h, m] = selectedTime.split(":").map(Number);

    const selectedDateTime = new Date(
      selectedDate.getFullYear(),
      selectedDate.getMonth(),
      selectedDate.getDate(),
      h,
      m,
      0
    );

    // 📌 menos de 60 minutos de antecedência → bloquear
    const diffMs = selectedDateTime - now;
    const diffMin = diffMs / 1000 / 60;

    if (diffMin < 60) return false;

    // 📌 horário já passou
    if (now >= selectedDateTime) return false;

    return true;
  };

  const buildWhatsappMessage = () => {
    const dataFmt = date ? format(date, "dd/MM/yyyy") : "";
    const periodoFmt = period === "lunch" ? "Almoço" : period === "dinner" ? "Jantar" : "";
    const pessoasFmt = guests || "";
    const localFmt = local || "";
    const nomeFmt = `${firstName} ${lastName}`.trim();

    // mensagem bonita e objetiva
    return (
      `Olá! Gostaria de confirmar minha reserva 👇\n\n` +
      `Nome: ${nomeFmt}\n` +
      `Telefone: ${telephone}\n` +
      `Data: ${dataFmt}\n` +
      `Período: ${periodoFmt}\n` +
      `Horário: ${time}\n` +
      `Local: ${localFmt}\n` +
      `Pessoas: ${pessoasFmt}\n\n` +
      `✅ Reserva registrada no site e aguardando confirmação.`
    );
  };

  const redirectToWhatsapp = () => {
    const text = encodeURIComponent(buildWhatsappMessage());
    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${text}`;
    window.location.href = url; // redireciona na mesma aba
  };

  // ==============================================================================
  // STEP 1
  // ==============================================================================
  const Step1 = (
    <Paper sx={{ p: 3, borderRadius: 3, mt: 4 }}>

      <Typography variant="h5" fontWeight={700} mb={3} color="#071739">
        Valores e Tolerância
      </Typography>

      <Typography mb={2}>
        Para reservas solicitamos depósito de sinal no valor de <strong>R$50,00 por pessoa</strong>.
        <br /><br />
        Nossas reservas possuem tolerância de <strong>15 minutos</strong> para atrasos.
        <br />
        Após este período, caso não haja manifestação de atraso do cliente,
        a reserva estará automaticamente cancelada.
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={accepted1}
            onChange={(e) => setAccepted1(e.target.checked)}

            sx={{
              '&.Mui-checked': {
                color: 'var(--azulEscuro)',
              },
            }}
          />
        }
        label="Li e concordo com os termos"
      />

      <Box mt={3} display="flex" justifyContent="flex-end">

        <Button
          variant="contained"
          sx={{ mt: 1, backgroundColor: 'var(--azulEscuro)', '&:hover': { backgroundColor: 'var(--azulEscuro)' } }}
          disabled={!accepted1}
          onClick={() => {
            setActiveStep(1);
            scrollToTop();
          }}
        >
          Continuar
        </Button>
      </Box>

    </Paper>
  );

  // ==============================================================================
  // STEP 2
  // ==============================================================================
  const Step2 = (
    <Paper sx={{ p: 3, borderRadius: 3, mt: 4 }}>

      <Typography variant="h5" fontWeight={700} mb={3} color="#071739">
        Política de Reservas
      </Typography>

      <Typography mb={2}>
        O valor do sinal depositado será descontado na comanda de consumo.
        <br /><br />
        O valor é por pessoa — se menos pessoas comparecerem, o valor correspondente
        à diferença <strong>não será ressarcido</strong>.
        <br /><br />
        Em caso de não comparecimento, o sinal <strong>não será reembolsado</strong>.
        O sinal é descontado na comanda.
        <br /><br />
        Em caso de chuva as reservas no <strong>Deck</strong> serão automaticamente canceladas.
        <br /><br />
        Cancelamentos com reembolso podem ser feitos até <strong>10 dias antes da reserva</strong>,
        com reembolso em até <strong>30 dias</strong>.
        Caso não compareça, não será ressarcido.
        <br /><br />
        Para confirmação, envie o comprovante no prazo informado.
        Após o horário limite, a mesa pode ser liberada sem aviso.
        <br />
      </Typography>

      <FormControlLabel
        control={
          <Checkbox
            checked={accepted2}
            onChange={(e) => setAccepted2(e.target.checked)}
            sx={{
              '&.Mui-checked': {
                color: 'var(--azulEscuro)',
              },
            }}
          />
        }
        label="Li e aceito a política de reservas"
      />

      <Box mt={3} display="flex" justifyContent="flex-end" gap={2}>

        <Button
          variant="outlined"
          onClick={() => {
            setActiveStep(0);
            scrollToTop();
          }}
          sx={{ mt: 1, color: "var(--azulEscuro)", borderColor: "var(--azulEscuro)", '&:hover': { borderColor: 'var(--azulEscuro)' } }}
        >
          Voltar
        </Button>

        <Button
          variant="contained"
          disabled={!accepted2}
          onClick={() => {
            setActiveStep(2);
            setFormOn(true);
            scrollToTop();
          }}
          sx={{ mt: 1, backgroundColor: 'var(--azulEscuro)', '&:hover': { backgroundColor: 'var(--azulEscuro)' } }}
        >
          Realizar Reserva
        </Button>
      </Box>

    </Paper>
  );

  // ==============================================================================
  // STEP 3 — FORMULÁRIO COMPLETO
  // ==============================================================================
  const Step3 = (
    <div className="reservas-card">

      <form onSubmit={handleSubmit}>

        {/* Nome */}
        <div className="two-cols">
          <div className="input-group">
            <label>Nome</label>
            <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} />
          </div>

          <div className="input-group">
            <label>Sobrenome</label>
            <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} />
          </div>
        </div>

        {/* Telefone */}
        <div className="input-group">
          <label>Telefone</label>
          <input
            type="text"
            maxLength={15}
            value={telephone}
            onChange={(e) => {
              let v = e.target.value.replace(/\D/g, "");
              if (v.length > 0) {
                v = v.replace(/^(\d{2})(\d)/g, "($1) $2");
                v = v.replace(/(\d{5})(\d)/, "$1-$2");
              }
              setTelephone(v);
            }}
          />
        </div>

        {/* Data */}
        <div className="input-group">
          <label>Data</label>

          <div className="datepicker-wrapper" onClick={() => setCalendarOpen(true)}>
            {date ? <span>{format(date, "dd/MM/yyyy")}</span> : <span className="placeholder">Selecione uma data</span>}
            <CiCalendarDate className="calendar-icon" />
          </div>

          {calendarOpen && (
            <div className="calendar-popup" ref={datepickerRef}>
              <DayPicker
                mode="single"
                selected={date}
                onSelect={(d) => {
                  setDate(d);
                  setCalendarOpen(false);
                  setPeriod("");
                  setTime("");
                }}
                locale={ptBR}
                disabled={isDayDisabled}
              />
            </div>
          )}
        </div>

        {/* Período */}
        <div className="input-group">
          <label>Período</label>

          <div className="radio-row">
            <label className={`radio-item ${!almocoDisponivel ? "disabled" : ""}`}>
              <input
                type="radio"
                value="lunch"
                checked={period === "lunch"}
                disabled={!almocoDisponivel}
                onChange={(e) => setPeriod(e.target.value)}
              />
              Almoço {!almocoDisponivel && "(indisponível)"}
            </label>

            <label className={`radio-item ${!jantarDisponivel ? "disabled" : ""}`}>
              <input
                type="radio"
                value="dinner"
                checked={period === "dinner"}
                disabled={!jantarDisponivel}
                onChange={(e) => setPeriod(e.target.value)}
              />
              Jantar {!jantarDisponivel && "(indisponível)"}
            </label>
          </div>
        </div>

        {/* Horário */}
        <div className="input-group">
          <label>Horário</label>
          <select value={time} disabled={!period} onChange={(e) => setTime(e.target.value)}>
            <option value="">Selecione um horário</option>

            {availableTimes.map((t) => {
              const disabled = !isTimeAvailable(date, period, t);

              return (
                <option key={t} value={t} disabled={disabled}>
                  {t} {disabled ? "(indisponível)" : ""}
                </option>
              );
            })}
          </select>
        </div>

        {/* Local */}
        <div className="input-group">
          <label>Local</label>
          <select value={local} onChange={(e) => setLocal(e.target.value)}>
            <option value="">Selecione</option>
            <option>Salão</option>
            <option>Deck</option>
          </select>
        </div>

        {local === "Deck" ? (
          <p style={{ textAlign: "left", marginBottom: 20 }}>Em caso de chuva as reservas no Deck serão automaticamente canceladas.</p>
        ) : false}

        {/* Pessoas */}
        <div className="input-group">
          <label>Número de Pessoas</label>

          <select value={guests} onChange={(e) => setGuests(e.target.value)}>

            <option value="">Selecione</option>

            {[1, 2, 3, 4, 5, 6, 7, 8].map(n => (
              <option
                key={n}
                value={n}
                disabled={capacidadeRestante !== null && n > capacidadeRestante}
              >
                {n} {capacidadeRestante !== null && n > capacidadeRestante ? "(indisponível)" : ""}
              </option>
            ))}

            {/* Caso 8+ sempre bloqueado quando não for possível */}
            <option
              value="8+"
              disabled={capacidadeRestante !== null && capacidadeRestante < 9}
            >
              8+ {capacidadeRestante !== null && capacidadeRestante < 9 ? "(indisponível)" : ""}
            </option>

          </select>

        </div>

        <button className="btn-submit" type="submit">
          Confirmar Reserva
        </button>

      </form>

    </div>
  );

  const renderStep = () => {
    if (activeStep === 0) return Step1;
    if (activeStep === 1) return Step2;
    return Step3;
  };

  return (
    <>
      <Header />

      <main className="reservas-main">
        <div className="reservas-container">
          <div className="reservas-header">
            <h1>Faça sua Reserva</h1>
            <p>{formOn ? "Garanta seu lugar e desfrute de uma experiência gastronômica única" : "Antes de reservar, leia nossa política para garantir a melhor experiência."}</p>
          </div>

          {!formOn && (
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label) => (
                <Step key={label}
                  sx={{
                    "& .MuiStepLabel-root .Mui-completed": {
                      color: "#0717398a",
                    },
                    "& .MuiStepLabel-root .Mui-active": {
                      color: "var(--azulEscuro)",
                    },
                    "& .MuiStepLabel-root .Mui-disabled": {
                      color: "#888686",
                    },
                  }}
                >
                  <StepLabel>
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          )}

          {renderStep()}

          {activeStep === 2 && (
            <div className="reservas-footer">
              <p><strong>Horário:</strong> Terça–Domingo: 13h às 15h30 / Terça–Sábado: 19h às 22h30</p>
            </div>
          )}
        </div>
      </main>

      <Footer />

      <Snackbar
        open={toastOpen}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        onClose={() => setToastOpen(false)}
      >
        <Alert
          severity={toastType}
          variant="filled"
          sx={{
            ...(toastType === "success" && {
              backgroundColor: "#5F8F43",
              color: "#fff",
              "& .MuiAlert-icon": {
                color: "#fff"
              }
            })
            ,
            ...(toastType === "error" && {
              backgroundColor: "#A63737",
              color: "#fff",
              "& .MuiAlert-icon": {
                color: "#fff"
              }
            })
          }}
        >
          {toastMessage}
        </Alert>
      </Snackbar>

      {loading && (
        <div className="loader-overlay">
          <div className="loader"></div>
        </div>
      )}
    </>
  );
};

export default Reservas;
